import { PaidSubscription, SubscriptionType } from "@/common/subscription";
import { ModuleName } from "@/common/product";

export function canRenderAdminProjects(subscription?: PaidSubscription) {
  return rendersModule(subscription, ModuleName.DBOT);
}

export function canRenderAdminMeetings(subscription?: PaidSubscription) {
  return rendersModule(subscription, ModuleName.DBOT);
}

export function canRenderArchive(subscription?: PaidSubscription) {
  return rendersModule(subscription, ModuleName.ARCHIVE);
}

export function canRenderMessages(subscription?: PaidSubscription) {
  return rendersModule(subscription, ModuleName.MESSAGING);
}

export function isOwnershipRegisterSubscription(subscription?: PaidSubscription) {
  return subscription?.modules?.includes(ModuleName.OWNERSHIP_REGISTER) === true;
}

export function isRegisterSubscription(
  subscription?: Pick<PaidSubscription, "productName" | "modules">,
) {
  return (
    Boolean(subscription?.productName) &&
    subscription?.modules?.includes(ModuleName.SHAREHOLDER_REGISTER) !== true
  );
}

function rendersModule(subscription: PaidSubscription | undefined, module: ModuleName) {
  if (!subscription) return true;
  if (isRegisterSubscription(subscription)) return subscription.modules?.includes(module) === true;
  return subscription.subscriptionType !== SubscriptionType.SHAREHOLDER_REGISTER_LEGACY;
}
